import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {UpdateRegistrationAffiliatedPage} from './update-registration-affiliated';

import {IonicSelectableModule} from 'ionic-selectable';
import {BrMaskerModule} from 'brmasker-ionic-3';

@NgModule({
  declarations: [
    UpdateRegistrationAffiliatedPage,
  ],
  imports: [
    IonicPageModule.forChild(UpdateRegistrationAffiliatedPage),
    IonicSelectableModule,
    BrMaskerModule,
  ],
  exports: [
    UpdateRegistrationAffiliatedPage
  ]
})
export class UpdateRegistrationAffiliatedPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/update-registration-affiliated/update-registration-affiliated.module.ts